var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterImg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 48,
    viewBox: "0 0 68 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_31041)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18_31041)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_18_31041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57 0.5H3C1.61929 0.5 0.5 1.61929 0.5 3V37C0.5 38.3807 1.61929 39.5 3 39.5H57C58.3807 39.5 59.5 38.3807 59.5 37V3C59.5 1.61929 58.3807 0.5 57 0.5Z",
    fill: "white",
    stroke: "#D5DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7353 11.459H24.6318V29.5395H34.7353V11.459Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2731 20.5C25.2731 16.8264 27.0051 13.568 29.6673 11.4597C27.7108 9.92639 25.241 9 22.5468 9C16.164 9 11 14.143 11 20.5C11 26.8569 16.164 32 22.5468 32C25.241 32 27.7108 31.0736 29.6673 29.5402C27.0051 27.4639 25.2731 24.1736 25.2731 20.5Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3665 20.5C48.3665 26.8569 43.2026 32 36.8198 32C34.1255 32 31.6558 31.0736 29.6992 29.5402C32.3935 27.4319 34.0934 24.1736 34.0934 20.5C34.0934 16.8264 32.3614 13.568 29.6992 11.4597C31.6558 9.92639 34.1255 9 36.8198 9C43.2026 9 48.3665 14.175 48.3665 20.5Z",
    fill: "#F79E1B"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_31041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18_31041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_18_31041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterImg5);
export default __webpack_public_path__ + "static/media/FooterImg5.03a42cc915a2a6657f77946c610134cd.svg";
export { ForwardRef as ReactComponent };